'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from 'react';
import Layout from 'Layouts/Front';
import resetStorageBookingValues from 'Functions/resetStorageBookingValues';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import PaymentCanceled from 'Components/Front/PaymentCanceled';
export default class RedirectCancelPage extends Component {
  state = {};
  componentDidMount() {
    resetStorageBookingValues();
  }
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const output = /*#__PURE__*/React.createElement(Layout, _extends({}, props, {
      "header-bemit": ['inline']
    }), /*#__PURE__*/React.createElement("div", {
      className: "page-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "o-content u-margin-top-30"
    }, /*#__PURE__*/React.createElement(PaymentCanceled, null, getFormStatus({
      error: 'Paiement annulé.'
    })))));
    return output;
  }
}
